export default __webpack_public_path__ + "static/media/side-bar-add.0ddb797a.svg";